import React from 'react';
import { Typography } from 'fronton-react';

type TFunction = (param: string) => string;

const getTitle = (translate?: TFunction) =>
  translate ? translate('calculator.dimensions.header') : 'Укажите параметры комнаты';

export const getDimensionsFormHeading = (isMobile: boolean | null, translate?: TFunction) => (
  <Typography variant={isMobile ? 'h2' : 'h1'} color="text-primary">
    {getTitle(translate)}
  </Typography>
);
